import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import ContentHeader from '../../components/ContentHeader';
import { AgentContacts } from './Components/AgentContacts';

const SellerAgentReportPage = () => {
  useDocumentTitle('Seller Agent Report');

  return (
    <>
      <ContentHeader title="Seller Agent Report" />
      <AgentContacts />
    </>
  );
};

export default SellerAgentReportPage;
